"use client";

import { Fragment } from "react";
import { useTranslations } from "next-intl";

const BRANDS = ["Megastore", "Bolmart", "Grandmart", "Novas Home"];
const COPIES = 3;

export default function NetworkMarquee() {
  const t = useTranslations("network");

  return (
    <div className="border-t-[1.5px] border-brand-navy">
      <div className="mx-auto flex max-w-[1240px] flex-col gap-3 px-4 py-6 sm:flex-row sm:items-center sm:gap-8 sm:px-6">
        <span className="shrink-0 text-sm font-semibold uppercase tracking-wider text-brand-muted-light">
          {t("subtitle")}
        </span>
        <span className="sr-only">{BRANDS.join(", ")}</span>
        <div
          aria-hidden="true"
          className="relative min-w-0 flex-1 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]"
        >
          <div className="flex w-max animate-hero-marquee motion-reduce:animate-none">
            {Array.from({ length: COPIES }).map((_, copy) => (
              <div key={copy} className="flex shrink-0 items-center">
                {BRANDS.map((brand) => (
                  <Fragment key={brand}>
                    <span className="whitespace-nowrap px-6 text-[30px] font-bold leading-none text-brand-navy">
                      {brand}
                    </span>
                    <span className="h-2.5 w-2.5 rotate-45 bg-brand-accent" />
                  </Fragment>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
